import { useState, useEffect } from 'react'
import checkTrailerFsk from '../functions/checkTrailerFsk'
import parseYoutubeId from '../functions/parseYoutubeId'

const useMaybeTrailer = (shouldPlayTrailer, trailerURL, fsk) => {
    const [maybeVideo, setMaybeVideo]  = useState('init')
    const [youtubeId, setYouTubeId]  = useState(false)

    useEffect(() => {
        if('init' === maybeVideo && trailerURL && checkTrailerFsk(fsk)) {
            const ytId = parseYoutubeId(trailerURL)

            if(ytId) {
                setYouTubeId(ytId)
            }
        }
    }, [])

    useEffect(() => {
        if(shouldPlayTrailer && youtubeId) {
            setMaybeVideo(true)
        } else {
            setMaybeVideo(false)
        }

    }, [shouldPlayTrailer, youtubeId])

    return [maybeVideo, youtubeId]
}

export default useMaybeTrailer